let breed = {
  CAT: [
    //top
    {
      breed: "中华田园猫",
      initial: "Z",
      id: "383977e8d8efd88cf33e71199cc37393"
    },
    {
      breed: "中国狸花猫",
      initial: "Z",
      id: "31cd6b4edef82912eee435944b8e4425"
    },
    {
      breed: "英国短毛猫",
      initial: "Y",
      id: "d2a4e7e5f904f76d96469076d41fafae"
    },
    {
      breed: "美国短毛猫",
      initial: "M",
      id: "fdc30c9433042ead57512e73f23ae699"
    },
    { breed: "布偶猫", initial: "B", id: "908d28a8e263d042ae7c3b18e4e08eb8" },
    { breed: "暹罗猫", initial: "X", id: "87a2c539e1d71e531ea3798ab176c436" },
    {
      breed: "斯芬克斯猫",
      initial: "S",
      id: "eb489bfec8e0fdc398109ba5cb263daf"
    },
    {
      breed: "苏格兰折耳猫",
      initial: "S",
      id: "92c535837af6985ff54444e60e454bc2"
    },
    { breed: "加菲猫", initial: "J", id: "7d59d5859f119768336deb4f6e0fadba" },
    { breed: "虎斑猫", initial: "H", id: "6eef35796c92d1473efa709215bd9092" },
    { breed: "橘猫", initial: "J", id: "299376551db5cfbbbd1c262925650f28" },

    {
      breed: "阿比西尼亚猫",
      initial: "A",
      id: "63c2816f43a7676087c747c5eb130063"
    },
    { breed: "奥西猫", initial: "A", id: "b580f2d361b3278cd09333b701e3df5b" },
    { breed: "埃及猫", initial: "A", id: "28ba7931cdb41b617eccdc3f4de9565e" },
    { breed: "波米拉猫", initial: "B", id: "c78056cf25dc6458115fe46a1238d814" },
    { breed: "巴厘猫", initial: "B", id: "02510900483453202e4c8f3f024b5199" },
    { breed: "波斯猫", initial: "B", id: "d7545586d61ca9d779403f43c4525ecd" },
    { breed: "伯曼猫", initial: "B", id: "28539284961ff1be702373b6f0ad7c09" },
    {
      breed: "德文卷毛猫",
      initial: "D",
      id: "31c3afa3d43c10e8d77f3c53e9018bc0"
    },
    { breed: "东奇尼猫", initial: "D", id: "eba212c96258dc358456bcfd1dedc7b3" },
    { breed: "东方猫", initial: "D", id: "7d221950f124705fc253db4f28585f7b" },
    {
      breed: "俄罗斯蓝猫",
      initial: "E",
      id: "15375081a22a72bc4d1c64af5b80cc75"
    },
    { breed: "哈瓦那猫", initial: "H", id: "c473fce282a24613ca4681de8d2722fb" },
    { breed: "金吉拉", initial: "J", id: "56d0adcde3b3838f5993214aa0dfd77f" },
    {
      breed: "加拿大无毛猫",
      initial: "J",
      id: "22127e35f97359f2153a81b69cebb903"
    },
    {
      breed: "柯尼斯卷毛猫",
      initial: "K",
      id: "fb667d691b58a54b4eefc521854e26b5"
    },
    { breed: "科拉特猫", initial: "K", id: "a1eb240faca5b04e9d33bad429380c7c" },
    {
      breed: "孟加拉豹猫",
      initial: "M",
      id: "6fd67e93d1bd33a7597d68a30de3ec5d"
    },
    { breed: "曼基康猫", initial: "M", id: "57bcca4375a6bb03f4bde466f62925cc" },
    { breed: "孟买猫", initial: "M", id: "9e6a845705b97e7422c1460410dd8fe5" },
    { breed: "缅因猫", initial: "M", id: "ae27fc410953b6c150374af1be67ff74" },
    { breed: "内华达猫", initial: "N", id: "e3b90353850fcf741a8dbc250204c280" },
    {
      breed: "欧洲缅甸猫",
      initial: "O",
      id: "57c919b051b992b95ad4b114dcd90042"
    },
    { breed: "卡尔特猫", initial: "Q", id: "b1cfdc831149bf56ce6afa776daf2cfd" },
    {
      breed: "日本短尾猫",
      initial: "R",
      id: "45e966c489423c6127caf7de1c324e29"
    },
    {
      breed: "塞尔凯克卷毛猫",
      initial: "S",
      id: "6773a8a2dc8ead52540a39dfdf8a2ea4"
    },
    { breed: "沙特尔猫", initial: "S", id: "377428006807bc7200e7d7beacebe71e" },
    {
      breed: "山东狮子猫",
      initial: "S",
      id: "66695cc7b04d6305e69aba1828299497"
    },
    { breed: "索马里猫", initial: "S", id: "f785c2ee52c6620422e94bb2056ab264" },
    {
      breed: "土耳其安哥拉猫",
      initial: "T",
      id: "87133534dba0b39e4c4a17024c16110b"
    },
    {
      breed: "土耳其梵猫",
      initial: "T",
      id: "9d659b04966019ebc20d8e0a1070562e"
    },
    { breed: "威尔士猫", initial: "W", id: "b2a61f3984a356c1d7f516168c7f28a0" },
    { breed: "夏特尔猫", initial: "X", id: "c3dc71cb1c82d8fa30875be1528063d0" },
    { breed: "新加坡猫", initial: "X", id: "6cf0614c62d42d843990ee8e1bcd3e8d" },
    {
      breed: "喜马拉雅猫",
      initial: "X",
      id: "0f5533c2ce640fc3ac70568ea3e876cd"
    },
    {
      breed: "西伯利亚森林猫",
      initial: "X",
      id: "700c21b14623baff3d95c0f456778695"
    },
    {
      breed: "异国短毛猫",
      initial: "Y",
      id: "b13c6ccf79716c64c94dce84cf90cf0c"
    },
    {
      breed: "重点色短毛猫",
      initial: "Z",
      id: "44cdab2cffe322cc79bf1834e515b27b"
    }
  ],
  DOG: [
    //top
    {
      breed: "中华田园犬",
      initial: "Z",
      id: "6afa01a8618d63dc75e353bbbffb9f77"
    },
    { breed: "串串", initial: "C", id: "1601e5cc74104a39c1b585ab69c6d2a1" },
    { breed: "泰迪犬", initial: "T", id: "9e3ba35038b95aa41236c769686006f6" },
    { breed: "哈士奇", initial: "H", id: "98347e56cba69497dec5d9bab5a9fc11" },
    { breed: "金毛犬", initial: "J", id: "924ea2e6a3b7d320b6ae193e7d10c3a8" },
    {
      breed: "阿拉斯加雪橇犬",
      initial: "A",
      id: "c55fd551e848b1a91312016b5ccbe3d9"
    },
    { breed: "萨摩耶犬", initial: "S", id: "6a34bcf8d25be2637b21cdf7428985c6" },
    { breed: "比熊犬", initial: "B", id: "208c9608d11c7647626de3dafac8ce5b" },
    {
      breed: "瑞典柯基犬",
      initial: "R",
      id: "fde3719ef2b9569ed6212c4d9d6842df"
    },
    { breed: "柴犬", initial: "C", id: "fbbad305fd0f232e8af5aac7b8350880" },
    { breed: "吉娃娃犬", initial: "J", id: "db63e4fddeeaaaffeaad7247ce9778ea" },
    { breed: "博美犬", initial: "B", id: "951501e205096b4bfd85508e5fcea535" },
    {
      breed: "德国牧羊犬",
      initial: "D",
      id: "7f6d1a908dca397862d30018e0956c70"
    },
    { breed: "巴哥犬", initial: "B", id: "eeed0364774f1493c2da6b98609c63a1" },
    {
      breed: "法国斗牛犬",
      initial: "F",
      id: "89bb793be2ffd898b41fd883363105ff"
    },
    { breed: "雪纳瑞", initial: "X", id: "3c54db09497888afcb29c9ebcf0f3580" },
    {
      breed: "苏格兰牧羊犬",
      initial: "S",
      id: "c6a73ab2bbc636b76e9f670467e819b0"
    },
    { breed: "松狮犬", initial: "S", id: "e0261501370e2f3b295ebac1a5ec802c" },
    {
      breed: "拉布拉多猎犬",
      initial: "L",
      id: "3592286c48635a45c79e09b313924b29"
    },
    { breed: "京巴犬", initial: "J", id: "7d1f31e5a891c8e3b09bbea558f7cad2" },

    { breed: "爱尔兰梗", initial: "A", id: "e207c9867ff8ffd5d1a00a87914a4c56" },
    {
      breed: "澳大利亚牧羊犬",
      initial: "A",
      id: "433118f9d1a7e99c028dbf0a7e2aa480"
    },
    {
      breed: "阿富汗猎犬",
      initial: "A",
      id: "0b2c967088687a3117479e530936beb2"
    },
    {
      breed: "爱尔兰猎狼犬",
      initial: "A",
      id: "78fef25d1f70c489b0c3364f647891a8"
    },
    {
      breed: "爱尔兰雪达犬",
      initial: "A",
      id: "dff606ef228ff402345450c2cabb2df1"
    },
    {
      breed: "澳大利亚梗",
      initial: "A",
      id: "5ee678fac2ba30e1506f9c85e5da66ff"
    },
    {
      breed: "安娜图牧羊犬",
      initial: "A",
      id: "f50722e204da678908748639e813f191"
    },
    {
      breed: "阿根廷杜高犬",
      initial: "A",
      id: "baab16dfbd4f38673d309e6a89a53f95"
    },
    { breed: "奥达猎犬", initial: "A", id: "1754644e09155fb679aa63070e980835" },
    {
      breed: "爱尔兰软毛梗",
      initial: "A",
      id: "efb743de5320385f79a163c2887eac83"
    },
    {
      breed: "标准雪纳瑞",
      initial: "B",
      id: "5a827ca84ec9a45ed7e3d6a2f633bf95"
    },
    {
      breed: "波士顿梗犬",
      initial: "B",
      id: "57983a091c34cdd5bf049eda8d9cf7c1"
    },
    {
      breed: "比利时格罗安达牧羊犬",
      initial: "B",
      id: "e75ad720a48837b3f36fc9695099ae53"
    },
    {
      breed: "比利时坦比连犬",
      initial: "B",
      id: "b05b28294dced353a6a3bedc89258b05"
    },
    {
      breed: "边境牧羊犬",
      initial: "B",
      id: "0cdfd5172d8498cc690b7fe0915431ea"
    },
    {
      breed: "巴吉度猎犬",
      initial: "B",
      id: "65ba0e36e55431c1a81dd968712ae4ab"
    },
    { breed: "比格犬", initial: "B", id: "6e41f6e11ab1a1e5594217b9a5a65e7c" },
    { breed: "伯瑞犬", initial: "B", id: "229fcccae840534d3592d0f294f25b78" },
    {
      breed: "比利时玛利诺犬",
      initial: "B",
      id: "a57bc62a8b7dfe9aca6afde373ecd1e6"
    },
    { breed: "贝灵顿梗", initial: "B", id: "ea1acfa3b9e5618afc083c354254b99e" },
    { breed: "波利犬", initial: "B", id: "c4a4d875409f4cb81f7b6c1e059f18d3" },
    { breed: "贝生吉犬", initial: "B", id: "917a1bc065982de447c7c755c31539d1" },
    { breed: "伯恩山犬", initial: "B", id: "c991a478bc561d1ef288295e6598d17a" },
    {
      breed: "冰岛牧羊犬",
      initial: "B",
      id: "7c3071f2c0bd17394df921d7d58ada3c"
    },
    { breed: "比特犬", initial: "B", id: "130b119e3b6ce26aec23bc3654d81c20" },
    { breed: "边境梗", initial: "B", id: "03dc4acffb4b28a89e15cc9e3fa57f59" },
    { breed: "藏獒", initial: "C", id: "54e1d14192b541d48cfaf6efba44cb4a" },
    {
      breed: "查理士王小猎犬",
      initial: "C",
      id: "87e3e55a12172cf9f2a1f703ca8c15b8"
    },
    { breed: "大麦町犬", initial: "D", id: "6c32e6232aa5cc23be8828e43ac427d3" },
    {
      breed: "德国短毛指示犬",
      initial: "D",
      id: "daa240c772d6a5443feccc94461289e3"
    },
    {
      breed: "大瑞士山地犬",
      initial: "D",
      id: "34e7b9198a741b7aba00971dde666843"
    },
    { breed: "东非猎犬", initial: "D", id: "502e21f35cb759541335339233b9adfd" },
    { breed: "大丹犬", initial: "D", id: "5e77b4ff14ece36d337924a83661ac5d" },
    { breed: "大白熊犬", initial: "D", id: "f915953d6ef4bf1f357dff118d4464dc" },
    {
      breed: "德国刚毛指示犬",
      initial: "D",
      id: "9b1274537cfebbe71272d461b5855b60"
    },
    { breed: "杜宾犬", initial: "D", id: "5b9b04712477dd1abce92122db3332f5" },
    {
      breed: "恩特雷布赫山地犬",
      initial: "E",
      id: "1c2120ed65d9c31714c526702d16f825"
    },
    { breed: "恶霸犬", initial: "E", id: "106d89a95a0ef6feab95bbc6237f4419" },
    {
      breed: "法老王猎犬",
      initial: "F",
      id: "fa8a1d3f1ebd7e3a308fbeef5079b6c5"
    },
    { breed: "芬兰猎犬", initial: "F", id: "62c2722f298f774b96581349f5d032c1" },
    {
      breed: "法兰德斯畜牧犬",
      initial: "F",
      id: "ad536b2a44ebc754a89175659e847ea6"
    },
    { breed: "贵宾犬", initial: "G", id: "7ced25d4c6fee3ef98b6cef9a85a292c" },
    {
      breed: "哥顿雪达犬",
      initial: "G",
      id: "880b3aef75d46a0d73b9a820f317a135"
    },
    { breed: "高加索犬", initial: "G", id: "84e74e5e36947cbf85cb0811f803ca2d" },
    {
      breed: "刚毛指示格里芬犬",
      initial: "G",
      id: "95ef7cf609f4997d53c51a36def51ee2"
    },
    { breed: "哥威斯犬", initial: "G", id: "627ca81b7b8008b0dac34aa9eaf958fe" },
    {
      breed: "刚毛猎狐梗",
      initial: "G",
      id: "c174a28a4001d867ff322475d976e970"
    },
    {
      breed: "古代长须牧羊犬",
      initial: "G",
      id: "9fd540a05441e6a788206ccc9bbef533"
    },
    {
      breed: "黑俄罗斯梗",
      initial: "H",
      id: "4cc6a9a7c698029ccc44991c15afb0f0"
    },
    {
      breed: "黑褐猎浣熊犬",
      initial: "H",
      id: "1ab4aaf884e81a4f414ecebe8232137f"
    },
    { breed: "蝴蝶犬", initial: "H", id: "0967bcd1a678b6982c4427524829c411" },
    { breed: "哈威那犬", initial: "H", id: "1deb8aac773319625b403a96f7fb9888" },
    { breed: "湖畔梗", initial: "H", id: "bcabb447fc63e4a1e2d3376ecdfa9565" },
    { breed: "惠比特犬", initial: "H", id: "4b88b4d906c3a3db7aea7e4891e23389" },
    {
      breed: "红骨猎浣熊犬",
      initial: "H",
      id: "f679efde2dcaccdd70aed87daa67f8ce"
    },
    {
      breed: "荷兰毛狮犬",
      initial: "H",
      id: "9b254a6e7f615b51b7b467d29d787214"
    },
    {
      breed: "巨型雪纳瑞",
      initial: "J",
      id: "78916535c8aa7ec01db1cee04d2c442d"
    },
    {
      breed: "卷毛寻回猎犬",
      initial: "J",
      id: "8c4c2c6bf794bd0c432d131f5ec56384"
    },
    {
      breed: "杰克罗素梗",
      initial: "J",
      id: "de78d749525425039a9813bc967f649c"
    },
    { breed: "捷克梗", initial: "J", id: "f1f0fda82cc693db0fbaf8d39f7ecde4" },
    {
      breed: "克伦伯猎鹬犬",
      initial: "K",
      id: "95755759a0759a4d3fa8ee47913dbcf5"
    },
    { breed: "凯安梗", initial: "K", id: "597cd6627130e08b1cb0a5fad0187887" },
    { breed: "凯利蓝梗", initial: "K", id: "1658503f4eba709480242d5c5d0eaa3f" },
    { breed: "可蒙犬", initial: "K", id: "65f77c6e0fa9b16b2e3baca2a72b9db8" },
    { breed: "罗威纳犬", initial: "L", id: "1f82e970708dc9f04ed3b04f945497af" },
    { breed: "罗威士梗", initial: "L", id: "3313df36e01e773b4d36cc8e05fb4336" },
    { breed: "罗福梗", initial: "L", id: "80170db08cc2df3ad6675c2033490142" },
    { breed: "拉萨犬", initial: "L", id: "19f4fe517aa879569b3538baf02f680b" },
    { breed: "腊肠犬", initial: "L", id: "7fdcae331c4a53b65f0265522603759e" },
    {
      breed: "迷你雪纳瑞",
      initial: "M",
      id: "74a61cf514cf099dccfd36d8234df81c"
    },
    {
      breed: "墨西哥无毛犬",
      initial: "M",
      id: "0b7e84e93397beebdd4afacd8c0327d6"
    },
    {
      breed: "美国水猎犬",
      initial: "M",
      id: "68255c533038d8155afafeb191b85263"
    },
    {
      breed: "迷你杜宾犬",
      initial: "M",
      id: "4b0a3bd79d4ec2a24e92ec786140eed7"
    },
    {
      breed: "迷你牛头梗",
      initial: "M",
      id: "0aa0e5e5b9e67676787db007aeb28743"
    },
    {
      breed: "美国猎狐犬",
      initial: "M",
      id: "9e185a43e9f3923c82fc8d3b1aee06a2"
    },
    {
      breed: "马尔济斯犬",
      initial: "M",
      id: "712788867d49aaae9a5d85b95ccae50d"
    },
    {
      breed: "美国斯塔福梗",
      initial: "M",
      id: "56211e142bcf9b4a7d0ee2f867f7d281"
    },
    {
      breed: "美国可卡犬",
      initial: "M",
      id: "edbc65911989717022dc30d44a11428d"
    },
    {
      breed: "曼彻斯特梗",
      initial: "M",
      id: "3b3ae2410fd8d8e52a55c4ba04583bc1"
    },
    { breed: "纽芬兰犬", initial: "N", id: "aa50a4ad3543f524c97b02a5a9dd34b3" },
    {
      breed: "那不勒斯獒",
      initial: "N",
      id: "dee760ad559ba68f1a9d79feac407608"
    },
    { breed: "牛头獒", initial: "N", id: "86a010187de3807f1ab477310cb41590" },
    { breed: "牛头梗", initial: "N", id: "74899825ee5709e644827ef860020e6f" },
    {
      breed: "平毛猎狐梗",
      initial: "P",
      id: "235eda1a612abaded1d65575120daee7"
    },
    {
      breed: "葡萄牙水犬",
      initial: "P",
      id: "b0bef0157cc3dd3e60d98ddf85318a99"
    },
    {
      breed: "平毛寻回猎犬",
      initial: "P",
      id: "c53483ce827aa60d6c93735194f87f1a"
    },
    {
      breed: "乞沙比克猎犬",
      initial: "Q",
      id: "19542f5fb9b9a0e82eb66cbed42f614b"
    },
    { breed: "拳师犬", initial: "Q", id: "994f5226add4b5b0a954acaf7aa76e46" },
    { breed: "卡斯罗犬", initial: "Q", id: "756240d117d021a5c6292740bd8f294d" },
    { breed: "秋田犬", initial: "Q", id: "6b81ff07f0d4f46471440c0389ce146e" },
    { breed: "卡南犬", initial: "Q", id: "70bdf79339ccb9167035cfbaeaf4b5b2" },
    {
      breed: "日本尖嘴犬",
      initial: "R",
      id: "cb54621e17e235ad897683ee8a1586d6"
    },
    { breed: "日本仲", initial: "R", id: "dd329a971c66c0d26a5c8e9a16e490a2" },
    {
      breed: "苏格兰猎鹿犬",
      initial: "S",
      id: "4568ce1a3f651fdbc8f61720d9ceb87f"
    },
    { breed: "斯开岛梗", initial: "S", id: "a1553691e160e0e5a6dcabdbb9864e36" },
    { breed: "史毕诺犬", initial: "S", id: "bb276f0eba615b37eed9d9bce51059ae" },
    { breed: "圣伯纳犬", initial: "S", id: "5e269c11510728eea0153e902838dcf0" },
    { breed: "苏格兰梗", initial: "S", id: "03ea96e7e4663d307baffe2ff3ea1a25" },
    { breed: "丝毛梗", initial: "S", id: "c8baa661c242c18e5233fc2521983f60" },
    {
      breed: "苏俄猎狼犬",
      initial: "S",
      id: "35a575360c45cdd35230f63990696710"
    },
    { breed: "沙皮犬", initial: "S", id: "771209f46f2183b5dd2674569fa3b0ef" },
    { breed: "威尔士梗", initial: "W", id: "4eb13adc3b7e37697042551ede248209" },
    {
      breed: "威尔士柯基犬",
      initial: "W",
      id: "8e64635f85a44c684be2147260acf045"
    },
    { breed: "威玛猎犬", initial: "W", id: "9cb12b2230a5d72b49c368d37bac5f74" },
    { breed: "维兹拉犬", initial: "W", id: "77e2b7d4fb62fd37df2310d7a3a65a4c" },
    {
      breed: "威尔士史宾格犬",
      initial: "W",
      id: "5844b74f0f87cd3d6401055054a3d574"
    },
    { breed: "寻血猎犬", initial: "X", id: "96456bfa9bf64c861fc695a9ee0e4247" },
    {
      breed: "喜乐蒂牧羊犬",
      initial: "X",
      id: "5f609e7337129b47bf9cd6532268f9c7"
    },
    { breed: "西藏梗", initial: "X", id: "e32f08de8160ce12beab60de2cfd29d7" },
    { breed: "西施犬", initial: "X", id: "e262cb381be42d5fa42d0977578a602e" },
    {
      breed: "西高地白梗",
      initial: "X",
      id: "a70504e20069a1979e9fc9b306efc599"
    },
    { breed: "西藏猎犬", initial: "X", id: "ec01eeba1bf14349051bce15aa9818e1" },
    { breed: "西里汉梗", initial: "X", id: "5f00f30ad3149d0a86f015cd4bbf1ca4" },
    {
      breed: "英国可卡犬",
      initial: "Y",
      id: "351e092b41cf85b007961777b78e3310"
    },
    { breed: "约克夏", initial: "Y", id: "0e9d2dc2928bafd019f26dc8ce523e41" },
    {
      breed: "英国古代牧羊犬",
      initial: "Y",
      id: "f4dc3066d0291efca23ac4975739a9e7"
    },
    {
      breed: "英国雪达犬",
      initial: "Y",
      id: "1517be1473815433e53bfb5fa9e9de52"
    },
    {
      breed: "英国史宾格猎犬",
      initial: "Y",
      id: "6fb70ec9c2bfaac8ac59025020c99a13"
    },
    {
      breed: "意大利灵缇犬",
      initial: "Y",
      id: "378d5b3814ff13da6d981369e2ab5e18"
    },
    {
      breed: "英国斗牛犬",
      initial: "Y",
      id: "3732f11a382770f34979aed6de428955"
    },
    {
      breed: "中国冠毛犬",
      initial: "Z",
      id: "2ff6ea401b501ebafe5e6a9e9ad64e9d"
    }
  ]
};

let ANIMAL = {
  OTHER: 0,
  CAT: 1,
  DOG: 2
};

// breedDict
let breedDict = {};
let breedIdDict = {};
let keyAnimals = Object.keys(breed);
keyAnimals.forEach(animal => {
  let breeds = breed[animal];
  for (let [, value] of breeds.entries()) {
    breedDict[value.id] = value.breed;
    breedIdDict[value.breed] = value.id;
  }
});

const searchLetter = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "J",
  "K",
  "L",
  "M",
  "N",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "W",
  "X",
  "Y",
  "Z"
];

// 根据id获取品种名过程
function getBreedName(id) {
  return breedDict[id];
}

// 根据 name 获取品种id
function getBreedId(name) {
  return breedIdDict[name];
}

//对城市信息进行分组
function breedList(animal) {
  let enAnimal = "";
  for (let [ani, value] of ANIMAL.entries()) {
    if (value == animal) {
      enAnimal = value;
    }
  }

  var tempObj = [];
  for (var i = 0; i < searchLetter.length; i++) {
    var initial = searchLetter[i];
    var breedInfo = [];
    var tempArr = {};
    tempArr.initial = initial;
    for (var j = 0; j < breed[enAnimal].length; j++) {
      let single = breed[enAnimal][j];
      if (initial == single.initial) {
        breedInfo.push(single);
      }
    }
    tempArr.cityInfo = [];
    tempObj.push(tempArr);
  }
  return tempObj;
}

function getBreedDict() {
  return breedDict;
}

function getBreedNameList(animal) {
  let selDict;
  if (animal === ANIMAL.CAT) {
    selDict = Object.assign({}, breed.CAT);
  } else if (animal === ANIMAL.DOG) {
    selDict = Object.assign({}, breed.DOG);
  }
  let breeds = Object.values(selDict);
  breeds = breeds.map(x => x.breed);
  return breeds;
}

export default {
  breed,
  ANIMAL: ANIMAL,
  searchLetter: searchLetter,
  breedList: breedList,
  getBreedDict: getBreedDict,
  getBreedName: getBreedName,
  getBreedId: getBreedId,
  getBreedNameList: getBreedNameList
};
